"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsAlphanumericValidator {
    constructor(locale) {
        this.locale = locale;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isAlphanumeric(input, this.locale);
        }
        return false;
    }
}
exports.IsAlphanumericValidator = IsAlphanumericValidator;
//# sourceMappingURL=IsAlphanumericValidator.js.map